/* eslint-disable no-param-reassign */

import api from '@/services/api/home/home';

export default {
  state: {
    tableList: [],
    countNumber: [],
    crossNum: 0,
    crossPermission: {},
    keyword: ''
  },

  mutations: {
    SET_MODULETREE: (state, data) => {
      state.moduleTree = data
    },
    SET_CROSS: (state, data) => {
      state.countNumber = data
      // let result = 0
      // for (let key in data) {
      //   result += Number(data[key])
      // }
      // state.crossNum = result
    },
    SET_PERMISSION: (state, data) => {
      state.crossPermission = data
    }
  },

  getters: {},

  actions: {
    async getNumberOfCrossProjects({ commit, state }) {
      let result = await api.getNumberOfCrossProjects({})
      commit('SET_CROSS',result)
    },
    getAppOverview({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        api
          .getAppOverview(params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            commit('SET_ROLELIST', {});
            reject(error);
          });
      });
    },
    async getPermissionIndex({ commit, state }) {
      let result = await api.getPermissionIndex({})
      commit('SET_PERMISSION',result)
    },
  },
};
